import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { state } from './state';

export const notifications = {
  actions,
  getters,
  mutations,
  state,
  name: 'notifications'
};
